// extracted by mini-css-extract-plugin
var _1 = "EntityTabPosts-moduleaddNew__eTwPr";
var _2 = "EntityTabPosts-modulecontainer__fxOP_";
var _3 = "EntityTabPosts-modulecontainerEmpty__E9CEv";
var _4 = "EntityTabPosts-modulefilterBar__kZ6Fk";
var _5 = "EntityTabPosts-modulefilterBarButtons__rIE_h FilterBar-modulebuttons__XBTsX";
var _6 = "EntityTabPosts-moduleheader___v1vD";
export { _1 as "addNew", _2 as "container", _3 as "containerEmpty", _4 as "filterBar", _5 as "filterBarButtons", _6 as "header" }
